import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppLink } from "../lib/route-primitives";
import { paths } from "../lib/paths";
import { JOIN_LAYOUTS, MOCK_WEDDING } from "./join/layouts";
import { DemoFormStub } from "./join/layouts/DemoFormStub";
import { PremiumLayoutHost } from "./join/PremiumLayoutHost";

export function DemoPage() {
  const { variant } = useParams<{ variant: string }>();
  const layout = JOIN_LAYOUTS.find((l) => l.id === variant) ?? JOIN_LAYOUTS[0];
  const Layout = layout.component;
  const [navOpen, setNavOpen] = useState(false);

  // Her sayfa yüklemesinde / variant değişiminde en üstten başla
  useEffect(() => {
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
    setNavOpen(false);
  }, [variant]);

  const originals = JOIN_LAYOUTS.filter((l) => l.tier === "original");
  const premium = JOIN_LAYOUTS.filter((l) => l.tier === "premium");

  return (
    <>
      {/* Toggle button */}
      <button
        onClick={() => setNavOpen((v) => !v)}
        className="fixed top-3 right-3 z-[10000] px-3 py-2 bg-black/70 backdrop-blur-md text-white rounded-lg text-xs font-medium uppercase tracking-widest cursor-pointer hover:bg-black/90 transition-colors flex items-center gap-2"
      >
        <span className="opacity-60">{layout.tier === "premium" ? "Premium" : "Original"}</span>
        <span className="text-white/30">/</span>
        <span>{layout.label}</span>
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" className={`transition-transform ${navOpen ? "rotate-180" : ""}`}>
          <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>

      {/* Slide-out demo nav */}
      {navOpen && (
        <div
          className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-sm"
          onClick={() => setNavOpen(false)}
        >
          <div
            className="absolute top-14 right-3 w-72 max-h-[80vh] overflow-y-auto bg-neutral-900/95 backdrop-blur-md rounded-xl border border-white/10 shadow-2xl p-2"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-3 pt-2 pb-1 text-[10px] uppercase tracking-[0.3em] text-white/40">Original</div>
            {originals.map((l) => (
              <AppLink
                key={l.id}
                to={paths.demo(l.id)}
                className={[
                  "block px-3 py-2 text-sm rounded transition-colors",
                  l.id === layout.id
                    ? "bg-white text-black font-medium"
                    : "text-white/70 hover:bg-white/10 hover:text-white",
                ].join(" ")}
              >
                {l.label}
              </AppLink>
            ))}

            <div className="px-3 pt-4 pb-1 text-[10px] uppercase tracking-[0.3em] text-amber-200/60 flex items-center gap-2">
              <span>Premium</span>
              <span className="flex-1 h-px bg-amber-200/20" />
            </div>
            {premium.map((l) => (
              <AppLink
                key={l.id}
                to={paths.demo(l.id)}
                className={[
                  "block px-3 py-2 text-sm rounded transition-colors",
                  l.id === layout.id
                    ? "bg-amber-200 text-black font-medium"
                    : "text-white/70 hover:bg-amber-200/10 hover:text-amber-100",
                ].join(" ")}
              >
                {l.label}
              </AppLink>
            ))}
          </div>
        </div>
      )}

      {/* Premium variants preview through the host (loader + preload); the
          variant key remounts it so each selection replays its loader. */}
      {/* Demo, gerçek API'ye DOKUNMAZ: burası stub'ın tek meşru çağrıldığı yer.
          Gerçek düğün sayfası (`/:slug/join`) aynı slot'a JoinRegisterForm geçirir. */}
      {layout.tier === "premium" ? (
        <PremiumLayoutHost
          key={layout.id}
          layoutDef={layout}
          {...MOCK_WEDDING}
          formSlot={<DemoFormStub />}
          config={layout.defaults}
        />
      ) : (
        <Layout {...MOCK_WEDDING} formSlot={<DemoFormStub />} />
      )}
    </>
  );
}
